<template>
    <span v-if="this.data.id">
        <b-button @click="handleViewNotificationClick" title="Notification Details" variant="default">
            <font-awesome-icon :icon="['fas', 'eye']"></font-awesome-icon>
        </b-button>
        <modal :id="viewNotificationModalID" :title="this.data.title" ok-title="OK" @shown="onModalShown">
            {{ this.data.message }}
        </modal>
    </span>
</template>

<script>
    import get from 'lodash/get';
    import Modal from '../../generic/modal/modal.vue';

    export default {
        components: {
            Modal,
        },
        data() {
            return {
                data: null,
                viewNotificationModalID: '',
            };
        },
        created() {
            this.data = this.params.data;
            this.viewNotificationModalID = `staylio-admin-view-notification-modal-${this.data.id}`;
        },
        methods: {
            get,
            onModalShown() {
                this.params.api.clearFocusedCell();
            },

            handleViewNotificationClick() {
                this.$bvModal.show(this.viewNotificationModalID);
            },
        },
    };
</script>
